import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><g fill="#000" fillRule="evenodd"><path d="M4 6.83L6.83 4 21 18.17 18.17 21 4 6.83zm1.42-.06l3.37 3.37 1.35-1.35-3.37-3.37-1.35 1.35zM18 12l.75-2.25L21 9l-2.25-.75L18 6l-.75 2.25L15 9l2.25.75zM13 7l.5-1.5L15 5l-1.5-.5L13 3l-.5 1.5L11 5l1.5.5zM5 16l.5-1.5L7 14l-1.5-.5L5 12l-.5 1.5L3 14l1.5.5z" /></g></svg>);